import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import {
  Paso3Body,
  Paso3Container,
  Paso3ContainerBotones,
  Paso3ContainerBotonesSMG,
  Paso3SMGContainer,
  Paso3Titulo,
} from "../ValidarCobertura/localStyle";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { IonSpinner } from "@ionic/react";
import InputV1 from "_+_Portal/components/Genericos/InputV1/InputV1";
import { useContext, useEffect, useState } from "react";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import {
  wsGetMontoLaboratorio,
  wsGetValidaOnlineTokenLaboratorio,
  wsPostValidaOnlineLaboratorio,
} from "_+_Portal/_-_Autocheckin/context/action/laboratorio";
import { GlobalContext } from "global/context/Provider";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { hideModal } from "_+_Portal/context/Actions/modal/modal";
import ModalToken from "_+_Portal/_-_Autocheckin/components/genericos/ModalToken/ModalToken";
import { PortalContext } from "_+_Portal/context/Provider";
import { showModal } from "global/context/action/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import Keyboard from "_+_Portal/components/Genericos/Keyboard/Keyboard";
import { LeftContainer, MainContainer, RightContainer } from "./localStyle";
import { getLocalStorage } from "global/utils/safeJsonParse";

const ValidacionCoberturaLabo = ({ turnoActual }) => {
  //#region  ------- useContext --------
  const { authState, modalDispatch, toasterDispatch } =
    useContext(GlobalContext);
  const { pasoDispatch, turnosSeleccionadosState, puntoControlDispatch } =
    useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);

  //#endregion  ---- useContext --------
  //#region  ------- useStates --------
  const [loading, setLoading] = useState(true);
  const [esSMG, setEsSMG] = useState(null);
  const [maxLength, setmaxLength] = useState();
  const [tipoToken, setTipoToken] = useState();
  const [token, setToken] = useState({ token: "" });
  const [isCompleteCero, setIsCompleteCero] = useState(false);
  const [intentos, setIntentos] = useState(0);
  const [esAccord, setEsAccord] = useState(null);

  //#endregion ----- useStates --------

  const handleVolver = () => {
    setPaso("ResumenLabo")(pasoDispatch);
  };
  const ingresarToken = (e) => {
    const value = e.target.value;
    setToken(value);
  };

  const bodyTxt =
    "Ingresá el token o código de seguridad que figura en la aplicación de tu cobertura médica.";
  const bodyTxtSmg =
    "Le pedimos que nos indique si cuenta con la aplicación de la cobertura para usar el token de autorización o si tiene la credencial física";
  const titleTxtSmg = "Autorización de la cobertura";
  const titleTxtAccord = "Autorización de la cobertura";
  const bodyTxtAccord =
    "¿Cuenta con la aplicación de su cobertura para utilizar el token de seguridad?";

  const irPuntoDeControl = () => {
    const idTipoPuntoControl = 9;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };
  const paciente = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.paciente
    : authState.auth?.data?.paciente;
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];
  let idTerminal = getLocalStorage("idTerminal");

  //#region  ------- useEffect --------
  useEffect(() => {
    const nextStep = (success, data) => {
      if (success && data.token) {
        setmaxLength(data.longitud <= 0 ? 6 : data.longitud);
        setTipoToken(data.tipo);
        setEsSMG(data.preguntarAppPaciente);
        setLoading(false);
        setIsCompleteCero(data.completaConCeros);
      } else if (success) {
        let dto = {};
        dto["tipoProceso"] = "2";
        dto["idTurno"] = turno?.idProtocolo;
        dto["idPaciente"] = paciente?.codigo;
        wsPostValidaOnlineLaboratorio([dto], finalizarToken);
      } else {
        setLoading(true);
        const idTipoPuntoControl = 10;
        setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
        setPaso("PuntoControl")(pasoDispatch);
      }
    };
    wsGetValidaOnlineTokenLaboratorio(turno?.idProtocolo)(nextStep);
  }, []);

  //#region  ------- funtions --------
  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const handleKeyboardChange = (newValue) => {
    setToken({ token: newValue });
  };

  const confirmarToken = () => {
    let dto = {};
    dto["tipoProceso"] = "2";
    dto["idTurno"] = turno?.idProtocolo;
    dto["idPaciente"] = paciente?.codigo;
    dto["osToken"] = token?.token;
    if (isCompleteCero && token?.token?.length < maxLength) {
      dto["osToken"] = addCero(token?.token, maxLength);
    }
    setLoading(true);
    wsPostValidaOnlineLaboratorio([dto])(finalizarToken);
  };

  const puntoControlAccord = () => {
    const idTipoPuntoControl = 9;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const validarSinToken = () => {
    let dto = {};
    dto["tipoProceso"] = "2";
    dto["idTurno"] = turno?.idProtocolo;
    dto["idPaciente"] = paciente?.codigo;
    setLoading(true);
    wsPostValidaOnlineLaboratorio([dto])(finalizarToken);
  };

  const handleClickVolver = () => {
    setPaso("TurnosDelDiaLabo")(pasoDispatch);
  };

  const actualizarTurno = (isCorrect, monto) => {
    if (monto > 0) {
      setPaso("AbonarMP")(pasoDispatch);
    } else {
      setPaso("CierreRecepcionLabo")(pasoDispatch);
    }
    setLoading(false);
  };

  const pedirToken = () => {
    setEsSMG(false);
  };

  const finalizarToken = (success, data) => {
    if (success && data?.success > 0) {
      // setLoading(false);
      wsGetMontoLaboratorio(turno?.idProtocolo)(actualizarTurno);
    } else {
      if (intentos < 2) {
        setToken("");
        if (esSMG) {
          showToaster(
            {
              texto: "Ha ocurrido un error al intentar validar",
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        } else {
          showModal(
            <ModalToken dissmiss={dissmiss} />,
            "Ups! Algo salió mal",
            dissmiss,
            false,
            {},
            "centro",
            true,
          )(modalDispatch);
        }
        setIntentos(intentos + 1);
      } else {
        setLoading(true);
        const idTipoPuntoControl = 10;
        setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
        setPaso("PuntoControl")(pasoDispatch);
      }
      setLoading(false);
    }
  };
  const addCero = (str, cant) => {
    if (str.length < cant) {
      str = "0" + str;
      return addCero(str, cant);
    } else {
      return str;
    }
  };

  //#endregion ----- funtions --------

  return (
    <>
      <LayoutPasos
        handleClick={handleClickVolver}
        volverTo={"/autocheckin/resumen"}
        type={"no-circle"}
        title={"Validación online"}
      >
        <CardBlueHeart
          medico={turno?.medico ? turno.medico : turno?.especialidad}
          turnoTitle={turno?.especialidad}
          pasoActual={turnoActual + 1}
          pasoTotal={listTurnosSeleccionado.length}
        />
        {loading ? (
          <Paso3Container>
            <span className={"spinner"}>
              <IonSpinner name="lines" />
            </span>
          </Paso3Container>
        ) : (
          <>
            {esSMG ? (
              <>
                <Paso3SMGContainer
                  initial={{ opacity: 0, y: -50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 100 }}
                  transition={{ duration: 0.4 }}
                >
                  <Paso3Body>
                    <span className="rb22b ValidaTurnoSmg-titulo">
                      {esAccord ? titleTxtAccord : titleTxtSmg}
                    </span>
                  </Paso3Body>
                  <Paso3Body>
                    <span className="rb18l ValidaTurnoSmg-bodytxt">
                      {esAccord ? bodyTxtAccord : bodyTxtSmg}
                    </span>
                  </Paso3Body>

                  {esAccord ? (
                    <Paso3ContainerBotonesSMG>
                      <button
                        className="btn btn-validaturno bgc-primary c-white rb18m"
                        onClick={pedirToken}
                      >
                        SI
                      </button>
                      <button
                        className="btn btn-validaturno bgc-danger c-white rb18m"
                        onClick={puntoControlAccord}
                      >
                        NO
                      </button>
                    </Paso3ContainerBotonesSMG>
                  ) : (
                    <Paso3ContainerBotonesSMG>
                      <button
                        className="btn btn-validaturno bgc-primary c-white rb18m"
                        onClick={pedirToken}
                      >
                        Aplicación de cobertura
                      </button>
                      <button
                        className="btn btn-validaturno bgc-primary c-white rb18m"
                        onClick={validarSinToken}
                      >
                        Credencial
                      </button>
                    </Paso3ContainerBotonesSMG>
                  )}
                </Paso3SMGContainer>
              </>
            ) : (
              <Paso3Container
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.4 }}
              >
                <PasoBar paso={"ValidarCobertura"} />
                <MainContainer>
                  <LeftContainer $idTerminal={idTerminal}>
                    <Paso3Titulo>
                      <span className={`${idTerminal ? "rb32b" : "rb18m"}`}>
                        Validación
                      </span>
                    </Paso3Titulo>
                    <hr className="ValidaTurno-separador"></hr>
                    <Paso3Body>
                      <span
                        className={`ValidaTurno-bodytxt ${idTerminal ? "rb24t" : "rb18m"}`}
                      >
                        {bodyTxt}
                      </span>
                      <div className="ValidaTurno-input">
                        <InputV1
                          clase="ValidaTurno-input"
                          placeholderText={"12254"}
                          onChange={ingresarToken}
                          inputType="number"
                          value={token.token}
                          className={"rb24t inputNonScroll"}
                        />
                      </div>
                    </Paso3Body>
                    <Paso3ContainerBotones>
                      {/* <button
                        className={`btn btn-validaturno bgc-danger c-white rb16m`}
                        onClick={irPuntoDeControl}
                      >
                        No lo tengo
                      </button> */}
                      <button
                        className={`btn btn-validaturno ${
                          token.token === "" || token.token === null
                            ? "bgc-grey65"
                            : "bgc-primary"
                        } c-white rb16m`}
                        onClick={confirmarToken}
                      >
                        Enviar
                      </button>
                    </Paso3ContainerBotones>
                  </LeftContainer>
                  {idTerminal && (
                    <RightContainer>
                      <Keyboard
                        value={token.token}
                        onChange={handleKeyboardChange}
                        onEnter={confirmarToken}
                        maxLength={8}
                        enterText="OK"
                        darkMode={true}
                      />
                    </RightContainer>
                  )}
                </MainContainer>
              </Paso3Container>
            )}
          </>
        )}
      </LayoutPasos>
    </>
  );
};

export default ValidacionCoberturaLabo;
